import { Stack, Typography, Box } from "@mui/material";
import { isEmpty } from "lodash";
import React, { FC } from "react";
import { WebShopIcon } from "../../WebShopIcon";
import { ProposalTableColumnProps } from "../lib/type";
import { DeepPartial } from "@/src/shared/models";
import { ParsedValue } from "../../TextWithValue";
import { cn } from "@/src/shared/utils/mergeTwClasses";

interface DesktopColumnHeaderContentProps
  extends DeepPartial<ProposalTableColumnProps> {
  isSelected: boolean;
  isEditing: boolean;
}

export const DesktopColumnHeaderContent: FC<
  DesktopColumnHeaderContentProps
> = ({ title, icon, price, isSelected, isEditing }) => {
  return (
    <>
      {!!(isSelected || isEditing) && (
        <div
          className={cn("absolute inset-0 z-10 shadow-active-proposal-cell", {
            "rounded-t-lg": isSelected || isEditing,
          })}
        ></div>
      )}
      <Stack
        className={cn(
          "absolute inset-0 h-fit items-center gap-3 bg-white px-4 pb-4 pt-6",
          {
            "rounded-t-lg": isSelected || isEditing,
            "z-40": isSelected || isEditing,
          },
        )}
      >
        <Typography className="text-sm font-semibold uppercase text-dark-blue">
          {title}
        </Typography>
        {!isEmpty(icon) && (
          <Box
            className="flex items-center justify-center"
            style={{
              width: 48,
              height: 48,
            }}
          >
            <WebShopIcon
              name={icon.name}
              width={icon.width}
              height={icon.height}
            />
          </Box>
        )}
        {price && (
          <Typography className="text-[28px] font-bold leading-[34px] text-dark-blue">
            <ParsedValue value={price} maskType="thousandSeparator" />
          </Typography>
        )}
      </Stack>
    </>
  );
};
